var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.90988 17.0661C7.52956 17.2011 7.12596 17.2005 6.66996 17.2C5.4494 17.2 4.32329 17.1999 3.54029 17.108C2.73013 17.0129 2.03596 16.8105 1.44795 16.3339C1.2321 16.159 1.03548 15.9613 0.86145 15.7444C0.387345 15.1533 0.185985 14.4556 0.0914005 13.6412C-2.36273e-05 12.8541 -1.55808e-05 11.8649 4.19182e-07 10.638V6.97911C-1.55808e-05 5.55353 -3.16978e-05 4.40442 0.12084 3.50069C0.246337 2.5624 0.514817 1.77239 1.13902 1.14494C1.76322 0.51749 2.54915 0.247617 3.48258 0.121465C4.38165 -3.92676e-05 5.63852 -2.33302e-05 7.05676 6.69831e-07C8.47501 -2.33302e-05 9.61813 -3.92676e-05 10.5172 0.121465C11.4507 0.247617 12.2366 0.51749 12.8608 1.14494C13.485 1.77239 13.7535 2.5624 13.8789 3.50069C13.9998 4.40444 13.9998 5.55352 13.9998 6.97913L13.9999 9.75853C14.0007 10.2892 14.0014 10.7602 13.8222 11.1952C13.6429 11.6303 13.3111 11.9628 12.9373 12.3375L9.11093 16.1836C8.78901 16.5081 8.50397 16.7953 8.14013 16.9703C8.06509 17.0064 7.98828 17.0384 7.90988 17.0661Z",
    fill: "#6929E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91002 17.0662C7.98834 17.0384 8.06522 17.0064 8.14018 16.9704C8.5041 16.7954 8.78906 16.5081 9.11106 16.1837L12.9373 12.3375C13.3112 11.9628 13.6431 11.6303 13.8223 11.1953C13.9013 11.0035 13.9454 10.8048 13.9699 10.5969H12.3852C11.2911 10.5969 10.7723 10.5976 10.0787 10.6908C9.35866 10.7876 8.75234 10.9948 8.27082 11.4763C7.7893 11.9578 7.58218 12.5641 7.4853 13.2842C7.39226 13.9764 7.39226 14.5012 7.39234 15.5907V17.1771C7.57098 17.1587 7.74274 17.1256 7.91002 17.0662Z",
    fill: "#6929E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 4.6C10.8 4.93137 10.5314 5.2 10.2 5.2H3.79995C3.46858 5.2 3.19995 4.93138 3.19995 4.6C3.19995 4.26863 3.46858 4 3.79995 4H10.2C10.5314 4 10.8 4.26863 10.8 4.6Z",
    fill: "#6929E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59999 7.79995C7.59999 8.13131 7.33135 8.39995 6.99999 8.39995H3.79995C3.46858 8.39995 3.19995 8.13131 3.19995 7.79995C3.19995 7.46851 3.46858 7.19995 3.79995 7.19995H6.99999C7.33135 7.19995 7.59999 7.46851 7.59999 7.79995Z",
    fill: "#6929E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectActive);
export default __webpack_public_path__ + "static/media/project-active.a60fe554efcf4d769ada3294dd125e87.svg";
export { ForwardRef as ReactComponent };